var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8535 16.146C16.9 16.1925 16.9368 16.2476 16.962 16.3083C16.9871 16.369 17.0001 16.4341 17.0001 16.4998C17.0001 16.5655 16.9871 16.6305 16.962 16.6912C16.9368 16.7519 16.9 16.8071 16.8535 16.8535C16.8071 16.9 16.7519 16.9368 16.6912 16.962C16.6305 16.9871 16.5655 17.0001 16.4998 17.0001C16.4341 17.0001 16.369 16.9871 16.3083 16.962C16.2476 16.9368 16.1925 16.9 16.146 16.8535L11.9998 12.7067L7.85354 16.8535C7.75972 16.9474 7.63247 17.0001 7.49979 17.0001C7.36711 17.0001 7.23986 16.9474 7.14604 16.8535C7.05222 16.7597 6.99951 16.6325 6.99951 16.4998C6.99951 16.3671 7.05222 16.2399 7.14604 16.146L11.2929 11.9998L7.14604 7.85354C7.05222 7.75972 6.99951 7.63247 6.99951 7.49979C6.99951 7.36711 7.05222 7.23986 7.14604 7.14604C7.23986 7.05222 7.36711 6.99951 7.49979 6.99951C7.63247 6.99951 7.75972 7.05222 7.85354 7.14604L11.9998 11.2929L16.146 7.14604C16.2399 7.05222 16.3671 6.99951 16.4998 6.99951C16.6325 6.99951 16.7597 7.05222 16.8535 7.14604C16.9474 7.23986 17.0001 7.36711 17.0001 7.49979C17.0001 7.63247 16.9474 7.75972 16.8535 7.85354L12.7067 11.9998L16.8535 16.146Z",
    fill: "#794FED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.a1196c8e8fe59c080379424256373494.svg";
export { ForwardRef as ReactComponent };